import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3)
    },
    searchWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    searchInput: {
        width: '466px !important',
        alignItems: 'flex-start',
        '& .MuiInputBase-root': {
            margin: '0',
            gap: theme.spacing(1),
            height: '40px',
            color: '#0000008f'
        }
    },
    buttonGroup: {
        overflow: 'hidden',
        border: '1px solid var(--primary - _states - outlinedBorder, rgba(33, 150, 243, 0.50)) !important',
        borderRadius: 'var(--borderRadius, 4px)'
    },
    boxItemEnd: {
        marginTop: 'auto',
        color: 'var(--text-secondary, rgba(0, 0, 0, 0.60))',
        fontFeatureSettings: "'liga' off, 'clig' off",
        /* typography/body2 */
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        letterSpacing: '0.17px',
        weight: '400',
        lineHeight: '143%'
    },
    header: {
        color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
        fontFeatureSettings: "'liga' off, 'clig' off",
        /* typography/h5 */
        fontFamily: 'Inter',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '133.4%' /* 32.016px */
    },
    customButton: {
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
        color: '#2196f3',
        '&.MuiButton-containedPrimary': {
            backgroundColor: '#2196f3 !important',
            color: '#FFF'
        }
    }
}))
